import codeGen from '@/assets/v2/icons/code-gen.svg';
import contentSummarization from '@/assets/v2/icons/content-summarization.svg';
import customerServiceAutomation from '@/assets/v2/icons/customer-service-automation.svg';
import documentationGeneration from '@/assets/v2/icons/documentation-generation.svg';
import blog from '@/assets/v2/icons/blog.svg';
import lorax from '@/assets/v2/icons/lorax.svg';
import predibase from '@/assets/v2/icons/predibase.svg';
import informationExtraction from '@/assets/v2/icons/information-extraction.svg';
import joinOurCommunity from '@/assets/v2/icons/join-our-community.svg';
import modelFineTuning from '@/assets/v2/icons/model-fine-tuning.svg';
import modelServing from '@/assets/v2/icons/model-serving.svg';
import resources from '@/assets/v2/icons/resources.svg';
import virtualPrivateCloud from '@/assets/v2/icons/virtual-private-cloud.svg';
import rftPlayground from '@/assets/v2/icons/rft-playground.svg';
import glossary from '@/assets/v2/icons/glossary.svg';
import fineTuningBenchmark from '@/assets/v2/icons/fine-tuning-benchmark.svg';

const navData = [
  {
    index: 0,
    name: 'Platform',
    submenu: true,
    subitems: [
      {
        name: 'Model Fine-tuning',
        url: '/fine-tuning',
        icon: modelFineTuning,
      },
      {
        name: 'Model Serving',
        url: '/serving',
        icon: modelServing,
      },
      {
        name: 'Virtual Private Cloud',
        url: '/predibase-virtual-private-cloud',
        icon: virtualPrivateCloud,
      },
      {
        name: 'RFT Playground',
        url: '/reinforcement-fine-tuning-playground',
        icon: rftPlayground,
      },
    ],
  },
  {
    index: 1,
    name: 'Docs',
    submenu: true,
    subitems: [
      {
        name: 'Predibase',
        url: 'https://docs.predibase.com/',
        icon: predibase,
      },
      {
        name: 'LoRAX',
        url: 'https://predibase.github.io/lorax/',
        icon: lorax,
      },
    ],
  },
  {
    index: 2,
    name: 'Customers',
    url: '/customers',
  },
  {
    index: 3,
    name: 'Models',
    url: '/models',
  },
  {
    index: 4,
    name: 'Pricing',
    url: '/pricing',
  },
  {
    index: 5,
    name: 'Solutions',
    submenu: true,
    subitems: [
      {
        name: 'Code Generation',
        url: '/code-generation',
        icon: codeGen,
      },
      {
        name: 'Content Summarization',
        url: '/content-summarization',
        icon: contentSummarization,
      },
      {
        name: 'Customer Service Automation',
        url: '/customer-service-automation',
        icon: customerServiceAutomation,
      },
      {
        name: 'Documentation Generation',
        url: '/documentation-generation',
        icon: documentationGeneration,
      },
      {
        name: 'Information Extraction',
        url: '/information-extraction',
        icon: informationExtraction,
      },
    ],
  },
  {
    index: 6,
    name: 'Resources',
    submenu: true,
    subitems: [
      {
        name: 'Blog',
        url: '/blog',
        icon: blog,
      },
      {
        name: 'Fine Tuning Benchmark',
        url: '/fine-tuning-index',
        icon: fineTuningBenchmark,
      },
      {
        name: 'Glossary',
        url: '/glossary',
        icon: glossary,
      },
      {
        name: 'Join our Community',
        url: 'https://discord.gg/CBgdrGnZjy',
        icon: joinOurCommunity,
      },
      {
        name: 'Resource library',
        url: '/resources',
        icon: resources,
      },
    ],
  },
];

export default navData;
